//================================================================
//  Application: Digital ERP
//================================================================

//  Product Owner: TBD
//  Created 01/05/24

//================================================================

//Libraries
import React from 'react';
import { Routes, Route } from 'react-router-dom';

//Contexts

//Pages
import NotFound from './Pages/NotFound/NotFound.js';
import Inventory from './Pages/Inventory/Inventory.js';
import Application from './Pages/Inventory/Pages/Application/Application.js';
import Agreement from './Pages/Inventory/Pages/Agreement/Agreement.js';
import Vendor from './Pages/Inventory/Pages/Vendor/Vendor.js';
import Subnet from './Pages/Inventory/Pages/Subnet/Subnet.js';
import Settings from './Pages/Inventory/Pages/Settings/Settings.js';

//Components
import Navbar from './Components/Navbar/Navbar';
import GlobalToast from './Components/GlobalToast/GlobalToast.js';
import Footer from './Components/Footer/Footer.js';

//Styles
import './App.css'
import 'bootstrap/dist/css/bootstrap.min.css';


export default function App() {

  //------------------------------------------------------
  //  Return HTML
  //------------------------------------------------------

  return (  
    <div className='App-Container'>

      {/* Nav */}
      <div className='App-Container-Nav'>
        <Navbar></Navbar>
      </div>

      {/* Body > Contains all pages in the app  */}
      <div className='App-Container-Body'>

        <GlobalToast></GlobalToast>

        <Routes>

          <Route path='/' element={<Inventory />} />
          <Route path='/inventory' element={<Inventory />} />
          <Route path='/inventory/agreement/:id' element={<Agreement />} />
          <Route path='/inventory/application/:id' element={<Application />} />
          <Route path='/inventory/vendor/:id' element={<Vendor />} />
          <Route path='/inventory/subnet/:id' element={<Subnet />} />
          <Route path='/settings' element={<Settings />} />
          <Route path='*' element={<NotFound />}></Route>
          
        </Routes>

        <Footer></Footer>

      </div>
      
    </div>
  )

  //------------------------------------------------------
}